module.exports = __webpack_public_path__ + "assets/highlightjs.f3418cdf.svg";